import type {
  CreateOrganizationRequest,
  Organization,
  OrganizationDetail,
} from '@/definitions/organization'
import type { PaginatedResponse } from '@/definitions/pagination'
import type { UpdateOrgProductFlagsRequest } from '@/definitions/productFlags'
import api from '@/services/api'

export interface FetchOrganizationsParams {
  page: number
  limit: number
  /** Matches display name or organization id. Omitted from the request when blank. */
  search?: string
}

export const FetchOrganizations = async (
  params: FetchOrganizationsParams
): Promise<PaginatedResponse<Organization>> => {
  const { page, limit, search } = params
  const response = await api.get<PaginatedResponse<Organization>>('/api/v1/organizations', {
    params: { page, limit, ...(search ? { search } : {}) },
  })
  return response.data
}

export const CreateOrganization = async (
  data: CreateOrganizationRequest
): Promise<OrganizationDetail> => {
  const response = await api.post<OrganizationDetail>('/api/v1/organizations', data)
  return response.data
}

export const FetchOrganization = async (orgId: string): Promise<OrganizationDetail> => {
  const response = await api.get<OrganizationDetail>(`/api/v1/organizations/${orgId}`)
  return response.data
}

/**
 * Replaces the organization's whole product flag set.
 *
 * The response reports what was actually stored, which is not always what was
 * asked for: a flag that provisions a third party can fail while the rest apply,
 * and the reason comes back in `integration_errors`.
 */
export const UpdateOrgProductFlags = async (
  orgId: string,
  data: UpdateOrgProductFlagsRequest
): Promise<OrganizationDetail> => {
  const response = await api.put<OrganizationDetail>(
    `/api/v1/organizations/${orgId}/product-flags`,
    data
  )
  return response.data
}
